import { useTranslation } from 'react-i18next';

export default function Packages() {
  const { t } = useTranslation('common');

  const serviceColumns = [
    {
      id: 1,
      icon: 'ri-drop-line',
      translationKey: 'cleaning',
    },
    {
      id: 2,
      icon: 'ri-tools-line',
      translationKey: 'maintenance',
    },
    {
      id: 3,
      icon: 'ri-sofa-line',
      translationKey: 'interiorDesign',
    },
    {
      id: 4,
      icon: 'ri-hammer-line',
      translationKey: 'renovation',
    },
  ];

  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="packages" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#8B9B7E] font-semibold text-sm tracking-wider uppercase mb-4">
            {t('packages.badge')}
          </p>
          <h2 className="font-serif text-4xl md:text-5xl text-[#2B2B2B] mb-6">
            {t('packages.title')}
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            {t('packages.subtitle')}
          </p>
        </div>

        {/* Service Packages Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {serviceColumns.map((service) => {
            const serviceData = t(`packages.serviceColumns.${service.translationKey}`, { returnObjects: true }) as any;
            const includes = Array.isArray(serviceData.includes) ? serviceData.includes : [];
            
            return (
              <div
                key={service.id}
                className="bg-white border-2 border-gray-200 rounded-3xl p-8 hover:border-[#8B9B7E] hover:shadow-xl transition-all"
              >
                <div className="flex items-center justify-center w-16 h-16 bg-[#8B9B7E]/10 rounded-2xl mb-6">
                  <i className={`${service.icon} text-3xl text-[#8B9B7E]`}></i>
                </div>

                <h3 className="text-2xl font-bold text-[#2B2B2B] mb-2">
                  {serviceData.title}
                </h3>
                
                {serviceData.subtitle && (
                  <p className="text-sm text-gray-500 mb-4">{serviceData.subtitle}</p>
                )}

                <p className="text-gray-600 mb-6 leading-relaxed">
                  {serviceData.description}
                </p>

                <div className="mb-6">
                  <h4 className="font-semibold text-[#2B2B2B] mb-3">{t('packages.includes')}</h4>
                  <ul className="space-y-2">
                    {includes.map((item: string, index: number) => (
                      <li key={index} className="flex items-start space-x-2">
                        <i className="ri-checkbox-circle-fill text-[#8B9B7E] text-lg flex-shrink-0 mt-0.5"></i>
                        <span className="text-sm text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <button
                  onClick={scrollToBooking}
                  className="w-full bg-[#8B9B7E] text-white py-3 rounded-lg font-semibold hover:bg-[#7a8a6d] transition-all whitespace-nowrap cursor-pointer"
                >
                  {t('packages.bookService')}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}